import { omit } from "@/lib/utils";
import { TIME_FORMAT_FULL } from "@/schemas/commonFields/time";
import { WriteTimesheetEntry } from "@/types/timesheetEntry";
import { WriteTimesheetEntryContractor } from "../types";

export const convertFormTimesheetEntryContractorsToWriteTimesheetEntry = (
  item: WriteTimesheetEntryContractor,
): WriteTimesheetEntry => {
  // We are omitting the id here because it is UI only id for React.
  // The original_id is the id of the item in the database.
  const { original_id, ...rest } = omit(item, ["id"]);

  // TODO: remove when AR-650 is ready
  // start of temp solution
  if (rest.break_time === undefined) {
    return {
      ...rest,
      break_time: TIME_FORMAT_FULL,
    };
  }
  // end of temp solution

  if (original_id === null) {
    return rest;
  }

  return {
    ...rest,
    id: original_id,
  };
};
